import { inject, Injectable } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { NATIVE_IMAGE_EXTENSIONS } from '../interfaces/file-preview.interface';

/**
 * DTO per la richiesta di preview tramite il controller FileSystem.
 */
export interface FilePreviewRequestDTO {
  fileId: string;
  archiveId: string;
  isRelativePath: boolean;
}

/**
 * API client per gli endpoint di preview del controller FileSystem.
 * Endpoint: POST /file-system/archive-file/preview/{type}
 */
@Injectable({
  providedIn: 'root',
})
export class FilePreviewApi {
  #http = inject(SiaHttpService);

  readonly #controller = 'file-system';

  /**
   * Recupera l'anteprima di un file dall'archivio.
   * Per PDF e immagini native restituisce un Blob, per gli altri tipi restituisce JSON.
   */
  retrievePreview(type: string, request: FilePreviewRequestDTO): Promise<any> {
    if (
      type === 'pdf' ||
      NATIVE_IMAGE_EXTENSIONS.includes(type) ||
      type === 'doc' ||
      type === 'docx'
    ) {
      return this.#http.post(
        `${this.#controller}/archive-file/preview/${type}`,
        request,
        { responseType: 'blob' },
      );
    }
    return this.#http.post(
      `${this.#controller}/archive-file/preview/${type}`,
      request,
    );
  }

  /**
   * Recupera il contenuto testuale (OCR) di un file dall'archivio.
   */
  retrieveTextContent(
    request: FilePreviewRequestDTO,
  ): Promise<{ textContent: string }> {
    return Promise.resolve({ textContent: '' });
  }

  /**
   * Scarica il file originale dall'archivio.
   */
  downloadFile(request: FilePreviewRequestDTO): Promise<Blob> {
    return this.#http.execDownload(
      `${this.#controller}/archive-file/download`,
      request,
    );
  }
}
